import { render, staticRenderFns } from "./BlogComp.vue?vue&type=template&id=2ba7fd34&"
import script from "./BlogComp.vue?vue&type=script&lang=js&"
export * from "./BlogComp.vue?vue&type=script&lang=js&"
import style0 from "./BlogComp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports